import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Actions as GROUPACTIONS } from "../../../store/actions/groupActions";
import { ClipboardIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/tooltip";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const GroupsRow = ({ group, setOpenModal, schemeName, deleteGroupModal, isAdmin, permissions, currency }) => {
	const percentageOptions = useMemo(() => {
		return [
			{ label: "%", value: true },
			{ label: currency, value: false },
		];
	}, [currency]);

	return (
		<tr key={group.id}>
			<td width="5%">
				{permissions && (
					<div
						className="btn btn-xs btn-default"
						style={{ marginLeft: 10, marginRight: 10 }}
						onClick={() => {
							setOpenModal(group);
						}}
					>
						<Tooltip content="Edit Group">
							<PencilSquareIcon
								className="h-5 w-5 text-dark-gray"
								style={{ marginTop: "3px" }}
							/>
						</Tooltip>
					</div>
				)}
				{isAdmin && (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(group.id)}
						style={{ marginRight: 10 }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}
			</td>
			<td>{group.name}</td>
			<td>{schemeName}</td>
			<td>
				{group.employeePercentage
					? `${group.employeeContribution}${percentageOptions?.find((p) => p.value)?.label}`
					: `${percentageOptions?.find((p) => !p.value)?.label}${group.employeeContribution}`}
			</td>
			<td>
				{group.employerPercentage
					? `${group.employerContribution}${percentageOptions?.find((p) => p.value)?.label}`
					: `${percentageOptions?.find((p) => !p.value)?.label}${group.employerContribution}`}
			</td>
			<td>
				{group.startDate && format(new Date(group.startDate), "do MMM yyyy")} -{" "}
				{group.endDate && group.endDate != "null" ? format(new Date(group.endDate), "do MMM yyyy") : "Now"}
			</td>

			<td>
				{permissions && (
					<div
						className="btn btn-xs btn-danger"
						style={{ marginLeft: 10, marginRight: 10 }}
						onClick={() => {
							deleteGroupModal(group);
						}}
					>
						<Tooltip content="Delete Group">
							<TrashIcon
								className="h-5 w-5"
								style={{ marginTop: "3px" }}
							/>
						</Tooltip>
					</div>
				)}
			</td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { group } = ownProps;

	const schemeName =
		state?.pensions?.scheme?.list?.find((scheme) => scheme.id == group.scheme)?.name || "Deleted Scheme";

	return {
		group,
		schemeName,
		isAdmin: state?.my?.profile?.isAdmin,
		permissions: state?.permissions?.my?.permissions?.pensions != "Read",
		currency: state?.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: (group) => dispatch(GROUPACTIONS.setOpenModal(true, group)),
	deleteGroupModal: (group) => dispatch(GROUPACTIONS.deleteGroupModal(true, group)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupsRow);
